import { html } from 'lit';
import type {
  LandingEditorElementFrame,
  LandingEditorTestimonialColumns,
} from '../../shared/editor/landingEditorTypes.js';

interface TestimonialLayoutControlsOptions {
  frame: LandingEditorElementFrame;
  updateFrame: (elementId: string, update: Partial<LandingEditorElementFrame>) => void;
}

const columnOptions: readonly LandingEditorTestimonialColumns[] = [1, 2, 3, 4];

const previewCells = (columns: LandingEditorTestimonialColumns) =>
  Array.from({ length: columns * 2 }, () => html`<span></span>`);

export const renderTestimonialLayoutControls = (options: TestimonialLayoutControlsOptions) => {
  const activeColumns = options.frame.testimonialColumns;
  const setColumns = (testimonialColumns?: LandingEditorTestimonialColumns) =>
    options.updateFrame('story.testimonials', { testimonialColumns });
  const activeLabel =
    activeColumns === 1 ? 'Untereinander' : activeColumns ? `${activeColumns} pro Reihe` : 'Automatisch';

  return html`
    <section class="vp-editor-panel-section">
      <div class="vp-editor-testimonial-layout">
        <header>
          <div>
            <strong>Testimonial-Layout</strong>
            <span>${activeLabel}</span>
          </div>
          <span class="icon-[material-symbols--view-module-outline]" aria-hidden="true"></span>
        </header>
        <div class="vp-editor-testimonial-layout-options" role="group" aria-label="Testimonials pro Reihe">
          <button
            type="button"
            class=${activeColumns === undefined ? 'is-active' : ''}
            aria-pressed=${activeColumns === undefined ? 'true' : 'false'}
            title="Automatisch – bestehendes Seitendesign"
            @click=${() => setColumns()}
          >
            <span class="vp-editor-testimonial-auto-preview" aria-hidden="true"><i></i><i></i><i></i></span>
            <small>Auto</small>
          </button>
          ${columnOptions.map(
            columns => html`
              <button
                type="button"
                class=${activeColumns === columns ? 'is-active' : ''}
                aria-pressed=${activeColumns === columns ? 'true' : 'false'}
                title=${columns === 1 ? 'Testimonials untereinander' : `${columns} Testimonials pro Reihe`}
                @click=${() => setColumns(columns)}
              >
                <span
                  class="vp-editor-testimonial-grid-preview"
                  style=${`--vp-editor-testimonial-preview-columns: ${columns}`}
                  aria-hidden="true"
                  >${previewCells(columns)}</span
                >
                <small>${columns}</small>
              </button>
            `,
          )}
        </div>
        <p>
          ${
            activeColumns === 1
              ? 'Alle Karten stehen übersichtlich untereinander.'
              : activeColumns
                ? `${activeColumns} Karten bilden eine Reihe. Auf Smartphones bleibt es automatisch eine.`
                : 'Verwendet das bestehende responsive Seitendesign.'
          }
        </p>
      </div>
    </section>
  `;
};
